<template>
  <div class="Footer">
    <div class=" main-1200-width">
      <div class="footer-line">
        <div class="footer-line-left">
          <img src="@/assets/ewm.png" alt="">
          <p>AFM探针商城</p>
        </div>
        <div class="footer-line-right">
          <div class="footer-line-right-item">
            <p class="line-header">快速导航</p>
            <p v-for="(item,index) in cateData" :key="index"><a :href="'/Screen?cate_id='+item.id">{{item.name}}</a></p>
          </div>
          <div class="footer-line-right-item">
            <p class="line-header">帮助中心</p>
            <p><a href="/register">用户注册</a></p>
            <p><a href="/article/business_license">营业执照</a></p>
            <p><a href="/article/process">下单流程</a></p>
          </div>
          <div class="footer-line-right-item">
            <p class="line-header">关于我们</p>
            <p><a href="/article/website_introduction">网站简介</a></p>
            <p><a href="/article/legal_statement">法律声明</a></p>
            <p><a href="/News">最新消息</a></p>
          </div>
          <div class="footer-line-right-item">
            <p class="line-header">联系我们</p>
            <p><a href="/article/contact_us">联系电话</a></p>
            <p><a href="/article/contact_us">联系邮箱</a></p>
            <p><a href="/article/contact_us">公司地址</a></p>
          </div>
          <div class="footer-line-right-item">
            <p class="line-header">战略合作</p>
            <p v-for="(item,index) in linksData" :key="index"><a target="_blank" :href="item.url">{{item.title}}</a></p>
          </div>
        </div>
      </div>
      <div class="copyright">
        <p>{{appInfo.copytime || ''}} {{appInfo.copyright || ''}}
          <a target="_blank" href="https://beian.miit.gov.cn/">{{appInfo.beian}}</a>
          <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo">{{appInfo.gwbeian}}</a>
        </p>
        <p>24小时 客服热线: {{appInfo.mobile}} Email: {{appInfo.email}}</p>
      </div>
    </div>
  </div>
</template>
<script>
  /* 百度自动提交 */
  (function(){
    let bp = document.createElement('script');
    let curProtocol = window.location.protocol.split(':')[0];
    /* if (curProtocol === 'https') {
             bp.src = 'https://zz.bdstatic.com/linksubmit/push.js';
     }
     else*/
    if (curProtocol === 'http') {
      bp.src = 'http://push.zhanzhang.baidu.com/push.js';
    }
    let s = document.getElementsByTagName("script")[0];
    s.parentNode.insertBefore(bp, s);
  })();

  import {mapGetters} from "vuex";
  import categoryApi from "@/api/category.js";
  import linkApi from "@/api/link.js";
  export default {
    data() {
      return {
        cateData : [],
        linksData: []
      };
    },
    computed: {
      ...mapGetters(['appInfo']),
    },
    created() {
      this.getData();
    },
    methods: {
      getData() {
        this.getCateData()
        this.getLinkData()
      },
      async getCateData() {
        let {data} = await categoryApi.list()
        this.cateData = data.children || []
      },
      async getLinkData() {
        let {data} = await linkApi.list()
        this.linksData = data || []
      }
    }
  };
</script>
<style lang="less" scoped>
  .Footer {
    width: 100%;
    color: #FFFFFF;
    min-width: 1200px;
    background: #333333;
  }

  .footer-line {
    width: 100%;
    display: flex;
    padding: 40px 20px;

    .footer-line-left {
      width: 25%;
      display: flex;
      align-items: center;
      padding-right: 40px;
      flex-direction: column;
      justify-content: center;

      img {
        width: 120px;
        height: 120px;
        object-fit: cover;
      }

      p {
        font-size: 18px;
        font-weight: bold;
        line-height: 48px;
      }
    }

    .footer-line-right {
      width: 75%;
      display: flex;
      justify-content: space-between;

      .footer-line-right-item {
        p.line-header {
          font-size: 18px;
          line-height: 18px;
          margin-bottom: 18px;
        }

        p {
          color: #DDDDDD;
          margin-bottom: 10px;

          a {
            color: #DDDDDD;
            font-size: 14px;
            line-height: 14px;
          }
        }

        p:last-child {
          margin-bottom: 0;
        }
      }
    }
  }

  .copyright {
    color: #DDDDDD;
    font-size: 14px;
    line-height: 28px;
    text-align: center;
    padding: 20px 0 30px;
    border-top: 1px solid #FFFFFF;

    a {
      color: #DDDDDD;
    }
  }
</style>
